// Profile reducer

import { API_STATUS } from '../../../utilities/constants';
import profileActionTypes from './profile.types';

export const INITIAL_STATE = {
  getProfileApiStatus: API_STATUS.IDLE,
  updateProfileApiStatus: API_STATUS.IDLE,
  user: {
    firstName: '',
    lastName: '',
    email: '',
    gender: '',
    street: '',
    city: '',
    stateProvince: '',
    country: '',
    zip: '',
    phoneNumber: '',
    streetLine1: '',
    streetLine2: '',
    family: []
  }
};

const profileReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // GET Profile Operations
    case profileActionTypes.GET_PROFILE_USER:
      return {
        ...state,
        getProfileApiStatus: API_STATUS.LOADING
      };
    case profileActionTypes.GET_PROFILE_USER_SUCCESS:
      return {
        ...state,
        getProfileApiStatus: API_STATUS.SUCCEEDED,
        user: action.resetInitialState ? INITIAL_STATE.user : action.user
      };
    case profileActionTypes.GET_PROFILE_USER_ERROR:
      return {
        ...state,
        getProfileApiStatus: API_STATUS.ERROR,
        user: INITIAL_STATE.user
      };

    // UPDATE Profile Operations
    case profileActionTypes.UPDATE_PROFILE:
      return {
        ...state,
        updateProfileApiStatus: API_STATUS.LOADING
      };
    case profileActionTypes.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        updateProfileApiStatus: API_STATUS.SUCCEEDED
      };
    case profileActionTypes.UPDATE_PROFILE_ERROR:
      return {
        ...state,
        updateProfileApiStatus: API_STATUS.ERROR
      };
    default:
      return state;
  }
};

export default profileReducer;
